/** @format */

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function sanitizeEditorInput(value: unknown): string {
  const raw = typeof value === 'string' ? value : value == null ? '' : String(value);
  // Remove non-printable control chars that can break CKEditor initialization.
  return raw.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '');
}

interface ContentBlockEditorProps {
  value?: string;
  onChange?: (html: string) => void;
  disabled?: boolean;
  editorKey?: string;
}

export default function ContentBlockEditor({
  value = '',
  onChange,
  disabled = false,
  editorKey = 'content-editor'
}: ContentBlockEditorProps) {
  const safeData = sanitizeEditorInput(value);

  return (
    <div className="content-editor__ckeditor-wrap">
      <CKEditor
        key={editorKey}
        editor={ClassicEditor}
        data={safeData}
        disabled={disabled}
        disableWatchdog
        config={{
          toolbar: {
            items: [
              'undo',
              'redo',
              '|',
              'heading',
              '|',
              'bold',
              'italic',
              '|',
              'link',
              'insertTable',
              'blockQuote',
              '|',
              'bulletedList',
              'numberedList',
              'outdent',
              'indent'
            ]
          }
        }}
        onError={() => {
          // Keep app stable when editor cannot initialize with malformed external content.
        }}
        onChange={(_event, editor) => {
          if (typeof onChange === 'function') {
            onChange(editor.getData());
          }
        }}
      />
    </div>
  );
}
